import React from 'react';
import { Table } from 'reactstrap';
import Modal from '../../../shared/components/Modal/Modal';

// Compara o estoque atual por tamanho com a proporção de vendas do
// período, e sugere quantas peças de cada tamanho o estoque deveria ter
// pra acompanhar a demanda real (% de vendas × total em estoque).
const SizeStockModal = ({ isOpen, onClose, stockBySize, salesBySize }) => {
  const stock = stockBySize || [];
  const sales = salesBySize || [];
  const totalStock = stock.reduce((sum, s) => sum + s.quantity, 0);
  const totalSales = sales.reduce((sum, s) => sum + s.quantity, 0);
  const salesBySizeMap = new Map(sales.map((s) => [s.size, s.quantity]));

  const rows = stock.map((s) => {
    const stockPct = totalStock > 0 ? (s.quantity / totalStock) * 100 : 0;
    const salesQty = salesBySizeMap.get(s.size) || 0;
    const salesPct = totalSales > 0 ? (salesQty / totalSales) * 100 : 0;
    const suggestedQty = totalSales > 0 ? Math.round((salesPct / 100) * totalStock) : null;
    return { size: s.size, quantity: s.quantity, stockPct, salesPct, suggestedQty };
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Estoque por tamanho" size="lg">
      {rows.length === 0 ? (
        <p className="text-muted mb-0">Sem estoque cadastrado.</p>
      ) : (
        <>
          <Table hover responsive size="sm">
            <thead>
              <tr>
                <th>Tamanho</th>
                <th className="text-right">Tenho em estoque</th>
                <th className="text-right">% do estoque</th>
                <th className="text-right">% das vendas no período</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.size}>
                  <td className="font-weight-bold">{r.size}</td>
                  <td className="text-right">{r.quantity}</td>
                  <td className="text-right">{r.stockPct.toFixed(1)}%</td>
                  <td className="text-right">{totalSales > 0 ? `${r.salesPct.toFixed(1)}%` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {totalSales > 0 ? (
            <div className="mt-3 p-3" style={{ background: '#f5f3ff', borderRadius: 8, fontSize: 13 }}>
              <strong>Sugestão com base nas vendas do período:</strong>
              <ul className="mb-0 mt-2 pl-3">
                {rows.map((r) => (
                  <li key={r.size}>
                    {r.salesPct.toFixed(0)}% das vendas foram tamanho <strong>{r.size}</strong> — pra acompanhar,
                    seu estoque desse tamanho deveria ter aproximadamente{' '}
                    <strong>{r.suggestedQty} peças</strong> (hoje tem {r.quantity}).
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p className="text-muted small mt-3 mb-0">
              Sem vendas no período selecionado pra calcular uma sugestão — troque o filtro de data pra ver a comparação.
            </p>
          )}
        </>
      )}
    </Modal>
  );
};

export default SizeStockModal;
